const PIX_TYPES = ["evp", "email", "cpf", "cnpj", "phone"];

function toNumberLoose(v) {
  if (v === null || v === undefined) return NaN;
  if (typeof v === "number") return v;
  const s = String(v).trim().replace(",", ".");
  return Number(s);
}

export function isValidPixKeyType(t) {
  return PIX_TYPES.includes(String(t || "").toLowerCase());
}

export function detectPixKeyType(key) {
  const k = String(key || "").trim();
  const emailRE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
  const phoneRE = /^\+?\d{10,15}$/;
  const cpfRE = /^\d{11}$|^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
  const cnpjRE = /^\d{14}$|^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
  const uuidLike = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const hex32 = /^[0-9a-f]{32}$/i;
  if (emailRE.test(k)) return "email";
  if (phoneRE.test(k)) return "phone";
  if (cpfRE.test(k)) return "cpf";
  if (cnpjRE.test(k)) return "cnpj";
  if (uuidLike.test(k) || hex32.test(k)) return "evp";
  return "evp";
}

export function normalizePixRow(row = {}) {
  const pixKey = String(row.pixKey || row.chave || row.key || "").trim();
  const amount = toNumberLoose(row.amount ?? row.valor ?? row.value ?? "");
  let pixKeyType = (row.pixKeyType || "").toString().toLowerCase().trim();
  if (!isValidPixKeyType(pixKeyType)) {
    pixKeyType = detectPixKeyType(pixKey);
  }
  return {
    amount,
    pixKey,
    pixKeyType,
    name: String(row.name || "").trim(),
    doc: String(row.doc || "").trim(),
    message: String(row.message || "").trim(),
  };
}

export function validatePixRow(row = {}) {
  const errors = [];
  if (!row.pixKey) errors.push("pixKey requerido");
  if (!isValidPixKeyType(row.pixKeyType)) {
    errors.push("pixKeyType inválido (evp|email|cpf|cnpj|phone)");
  }
  const n = toNumberLoose(row.amount);
  if (!n || isNaN(n) || n <= 0) errors.push("amount inválido (>0)");
  return errors;
}

export function summarize(list = []) {
  const total = list.reduce((acc, r) => acc + (toNumberLoose(r.amount) || 0), 0);
  const count = list.length;
  return { count, total };
}

export function mapForApi(list = []) {
  return list.map((r) => ({
    amount: toNumberLoose(r.amount),
    pixKey: r.pixKey,
    pixKeyType: isValidPixKeyType(r.pixKeyType) ? r.pixKeyType : detectPixKeyType(r.pixKey),
    name: r.name || "",
    doc: r.doc || "",
    message: r.message || "",
  }));
}


